import { SettingsPermissions } from "@redotech/account-common/permissions";
import type { PermissionHandle } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { isCapabilityEnabled } from "@redotech/redo-team-common/capability-status";

export const canManageLandedCostPages: PermissionHandle = ({
  team,
  userPermissions,
}) =>
  isCapabilityEnabled(team, "landedCost") &&
  (userPermissions?.has(SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS) ??
    false);
